import projectsApi from '@/api/projects';

const state = {
  projects: [],
  project: {},
};


export const actions = {
  getList({ commit, dispatch }) {
    projectsApi.getProjects().then((data) => {
      dispatch('setProjects', data);
    });
  },

  get({ commit }, arg) {
    projectsApi.getProject(arg).then((data) => {
      commit('project', data.project);
    });
  },

  save({ commit, dispatch }, args) {
    if (args.project != undefined) {
      args = args.project
    }
    projectsApi.saveProject(args).then((data) => {
      projectsApi.getProjects().then((data) => {
        dispatch('setProjects', data);
        commit(
          'alert/add',
          {
            title: 'Informations',
            message: 'Le projet a été modifié avec succès!',
            variant: 'success',
            icon: 'check_circle',
          },
          { root: true },
        );
      })
    });
  },
  //Ajout des champs pour modifier les données directement dans la table
  setProjects({ commit }, args) {
    let projects = args.projects.map(x => {
      x.disabled = true;
      x.oldValue = {};
      return x;
    })
    commit('projects', projects);
  },
  search({ commit }, arg) {
    projectsApi.searchProject(arg).then((data) => {
      commit('projects', data.projects);
    });
  },

  delete({ dispatch }, args) {
    projectsApi.deleteProject(args).then(() => {
      dispatch('getList');
    });
  },
};
export const mutations = {
  projects(state, payload) {
    state.projects = payload;
  },
  project(state, payload) {
    state.project = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
